import swiper from './swiper'
import carousel from './carousel'

export default new Vue({
    el: '#bar',

    mounted() {
        if ($app.isModerator) {
            $.getScript('/assets/js/bar-card-admin.js')
        }

        this.processTabs()
        this.askWannaVisit()
        this.initTabMenu(this.$el)
        $helpers.initTooltips(this.$el)
        $('#bron-form').processBronForm()
        this.processMetroClosest(this.$el)
        this.$nextTick(() => carousel.bindMain('.bar__swiper'))

        if (this.$refs.wideMap) {
            this.initWideMap()
        }

        let firstBronBtn = document.querySelector('a[href*="/bar/bron?id="]')

        if (location.hash === '#bron') {
            this.$nextTick(() => firstBronBtn.click())
        }

        this.$el.querySelectorAll('a[href="#bron"]').forEach(a => a.addEventListener('click', () => firstBronBtn.click()))

        if (this.$el.dataset.cutPhone !== undefined) {
            $helpers.cutPhoneForClick()
        }

        if ($app.Favorite) {
            $app.Favorite.process(this.$el, '.bar__favorite')
        } else {
            this.$el.querySelector('.bar__favorite')?.remove()
        }
    },

    methods: {
        askWannaVisit() { // появление верхней плашки с вопросом посетить в заведение
            let container = this.$el.querySelector('.bar__notify')

            if (container) {
                let params = {
                    barId: $app.barId,
                    barName: container.dataset.name
                }

                setTimeout(() => $.get($app.urlPrefix + '/bar/index/wannaVisitAsk', params, response => {
                    if (response.panel) {
                        container.innerHTML = response.panel
                        container.classList.add('popup--visible')
                        container.querySelector('.fancybox3').addEventListener('click', () => container.classList.remove('popup--visible'))
                    }
                }), $app.isDebug ? 1000 : 4000)
            }
        },

        wannaVisit(eventParam, btn) { // клики на кнопки в верхней плашке сверху с вопросом посетить заведение
            if (btn.dataset.close !== undefined) {
                $.post($app.urlPrefix + '/bar/index/wannaVisitAnswer', { barId: $app.barId }, () => {
                    btn.closest('.bar__notify').classList.remove('popup--visible')
                })
            }

            $app.runEvent('click', { 'планируете посетить' : eventParam })
        },

        processMetroClosest(container) { // подгрузка слайдов для ближайших заведений
            let p = 2

            swiper(container.querySelector('.bar__tab-content[data-id="#closest"] .swiper'), {
                pagination: { type: null },
                on: {
                    reachEnd: s => {
                        $.get($app.urlPrefix + '/bar/index/barClosest', { p, id: $app.barId }, ({ slides }) => {
                            if (slides.length) {
                                p++

                                s.appendSlide(slides)
                            }
                        })
                    }
                }
            })
        },

        initWideMap() { // инициализация широкой карты в блоке контактов
            let coords = JSON.parse(this.$refs.wideMap.dataset.coords),
                params = {
                    controls: [],
                    behaviors: ['drag', 'dblClickZoom', 'multiTouch']
                }

            new YandexMap(this.$refs.wideMap, coords, $app.ymapApiKey, params).then(Map => {
                Map.map.geoObjects.add(
                    Map.makePlacemark(coords, this.$refs.wideMap.dataset.preset)
                )
            })
        },

        hideMobileStickyPanel(target) { // закрытие нижней фиксированной панельки на мобилках
            $.post($app.urlPrefix + '/bar/index/hideMobileStickyPanel', { barId: $app.barId }, () => {
                target.parentNode.remove()
                this.$el.classList.remove('mb-5')
                $app.runEvent('click', 'from-mobile-sticky-panel.close')
            })
        },

        processTabs() { // обработка основных вкладок
            let tabsWrapper = this.$el.querySelector('.bar__tabs-wrapper'),
                tabs = tabsWrapper.querySelectorAll('.bar__tab'),
                selectedTab = tabs[0]

            tabs.forEach(tab => {
                let selectedByUrl = tab.dataset.id === location.hash || location.pathname.endsWith(tab.dataset.id)

                if (selectedByUrl) {
                    selectedTab = tab //отмечаем активную вкладку по хешу или хвосту
                }

                tab.addEventListener('click', event => {
                    if (event.isTrusted) {
                        $app.runEvent('click', { карточка: { 'основные вкладки': tab.textContent.replace(/\(\d+\)/, '').trim() } } )

                        if ($app.isMobile && ! tab.classList.contains('bar__tab--selected')) {
                            this.$nextTick(() => tab.scrollIntoView({ behavior: 'smooth' }))
                        }

                        if (tab.dataset.id === '/dostavka') {
                            $helpers.processDostavkaClick(event, this.$el.dataset.dostavkaPaid !== undefined, this.$el.dataset.phone)
                        }
                    }

                    if (tab.dataset.preventless === undefined || selectedByUrl) {
                        event.preventDefault()
                    } else {
                        return true // для вкладок-ссылок, чтобы просто открыть новую страницу
                    }

                    /**
                     * @todo так как Vue портит dom (он становится непримонтированным к документу), то приходится каждый раз по новой искать все контейнеры вкладок
                     */
                    let tabContents = this.$el.querySelectorAll('.bar__tab-content')

                    tabs.forEach((t, i) => {
                        // для мобил разрешаем активировать/деактивировать одну и ту же вкладку
                        let isActive = tab === t && ! ($app.isMobile && tab.classList.contains('bar__tab--selected')),
                            tContent = tabContents[i]

                        t.classList.toggle('bar__tab--selected', isActive)
                        tContent.classList.toggle('d-none', ! isActive)

                        if (tab === t && tContent.childNodes.length === 0) {
                            tContent.innerHTML = '<img src="/assets/images/loader.svg" class="d-block mx-auto" style="width:100px" alt="Загрузка..." title="Загрузка...">'

                            $.get(tab.href.replace('#', '/tab/'), response => {
                                tContent.innerHTML = response.content

                                switch (tab.dataset.id.replace(/[#/]/, '')) {
                                    case 'menu':
                                        this.initTabMenu(tContent)
                                        break
                                    case 'banket':
                                        /** @todo подменяем вкладку по вышеуказанной причине, чтобы код ниже отработал корректно */
                                        tContent = new Vue({ el: tContent, mounted() { $bar.initTabMenu(this.$el) }}).$el
                                        break
                                    case 'otzyvy':
                                        $app.form.review()
                                        break
                                    case 'closest':
                                        this.processMetroClosest(tContent)
                                        break
                                }

                                carousel.bindMini(tContent)
                                $helpers.initTooltips(tContent)
                            })
                        }
                    })
                })

                if ($app.isMobile) {
                    this.observeSticked(tab)
                }
            })

            if (! $app.isMobile) {
                this.observeSticked(tabsWrapper.querySelector('.bar__tabs'))
            }

            document.querySelectorAll('.bar__tab-content').forEach(t => {
                if (selectedTab.dataset.id !== t.dataset.id || $app.isMobile) {
                    t.classList.add('d-none')
                }
            })

            if ($app.isMobile) {
                if (selectedTab === tabs[0]) {
                    return //на мобилах не активируем первую вкладку после загрузки
                }
            } else {
                selectedTab.parentNode.addEventListener('wheel', event => {
                    event.preventDefault()

                    event.currentTarget.scrollLeft += event.deltaY
                })
            }

            selectedTab.click()
        },

        observeSticked(item) {
            return new IntersectionObserver(
                ([e]) => e.target.classList.toggle('--sticked', e.intersectionRatio < 1),
                {threshold: [1]}
            ).observe(item)
        },

        goToTab(link, eventParam) { // активация вкладки и переход к ней
            $app.runEvent('click', { карточка: eventParam || link.title || link.textContent.trim() })

            if (this.$el) {
                let tab = this.$el.querySelector(`.bar__tab[data-id="${link.dataset.tab}"]`)

                if (tab) {
                    $helpers.scrollToElementAndThen(tab, () => {
                        if (! tab.classList.contains('bar__tab--selected')) {
                            tab.click()
                        }
                    })
                }
            }

            return false
        },

        initTabMenu(container = document) {
            carousel.bindMini(container)
            carousel.bindSingle(container)
            $helpers.initFoodMenu(container)
        },

        // processBlago() {
        //     $.get($app.urlPrefix + '/blago/data', response => {
        //         if (response.participants.indexOf(parseInt($app.barId)) < 0) {
        //             $('.blago-banner').hide();
        //         } else {
        //             $('.blago-banner-stat').text(response.durationText);
        //         }
        //     });
        // },

        // initInstinct() {
        //     window.ws_OnInstinctLoad = () => {
        //         setTimeout(() => {
        //             $.get($app.urlPrefix + '/bar/index/instinct', ({isActive}) => {
        //                 if (isActive) {
        //                     window.wsInstinct.startShow();
        //                 }
        //             });
        //         }, $app.isDebug ? 2000 : $helpers.getRandomInt(5, 10));
        //     }
        // }
    }
});
